import styled from 'styled-components';

export const Divs = styled.div`

`;